import React, { FC } from 'react'

type IconProps = {
  className?: string
  size?: number
}
export const FacebookIcon: FC<IconProps> = ({ className, size }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={size}
      viewBox={'0 0 24 24'}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M21.2999 12.0563C21.2999 16.7063 17.8875 20.5688 13.425 21.2438V14.7563H15.6L16.0125 12.0563H13.425V10.3313C13.425 9.58126 13.8 8.86876 14.9625 8.86876H16.125V6.58126C16.125 6.58126 15.075 6.39376 14.025 6.39376C11.925 6.39376 10.5375 7.70626 10.5375 10.0313V12.0563H8.17495V14.7563H10.5375V21.2438C6.07495 20.5688 2.69995 16.7063 2.69995 12.0563C2.69995 6.91876 6.86245 2.75626 12 2.75626C17.1375 2.75626 21.2999 6.91876 21.2999 12.0563Z'
        }
        fill={'#262626'}
      />
    </svg>
  )
}
